import React from "react";
import Auth0Login from "./login/Auth0Login";

export default function SignIn(): React.ReactElement {
  return <Auth0Login />;
}
